<div class="d-flex flex-column justify-content-start snack-bar-message-container">
  <div class="d-flex justify-content-between align-items-center">
    <span class="conversation__name">{{ conversation?.name }}</span>
    <span class="conversation__date">{{ this.data.createdAt | momentAgo }}</span>
  </div>
  <span class="message__content" [innerHTML]="this.data.content"></span>
</div>
